export interface Language {
  name: string;
  value: string;
  countryISO: string; // Country Alpha-2 ISO Code
  code2: string; // ISO-639-1 Language Code
  code3: string; // ISO-639-2 Language Code
}

// Alphabet order
// Lang codes: https://www.science.co.il/language/Codes.php
export enum LanguageCode {
  ar = 'ar',
  cs = 'cs',
  de = 'de',
  en = 'en',
  es = 'es',
  fr = 'fr',
  hi = 'hi',
  hu = 'hu',
  kk = 'kk',
  ky = 'ky',
  pl = 'pl',
  pt = 'pt',
  ru = 'ru',
  sl = 'sl',
  tg = 'tg',
  tr = 'tr',
  uk = 'uk',
  uz = 'uz',
  vi = 'vi',
}

// Alphabet order
export const AVAILABLE_LANGUAGES_MAP: Map<LanguageCode, Language> = new Map([
  [LanguageCode.ar, { value: LanguageCode.ar, countryISO: 'ar', code2: 'ar', code3: 'ara', name: 'عرب' }],
  [LanguageCode.cs, { value: LanguageCode.cs, countryISO: 'cz', code2: 'cs', code3: 'cze', name: 'Čeština' }],
  [LanguageCode.de, { value: LanguageCode.de, countryISO: 'de', code2: 'de', code3: 'ger', name: 'Deutsch' }],
  [LanguageCode.en, { value: LanguageCode.en, countryISO: 'gb', code2: 'en', code3: 'eng', name: 'English' }],
  [LanguageCode.es, { value: LanguageCode.es, countryISO: 'es', code2: 'es', code3: 'spa', name: 'Español' }],
  [LanguageCode.fr, { value: LanguageCode.fr, countryISO: 'fr', code2: 'fr', code3: 'fre', name: 'Français' }],
  [LanguageCode.hi, { value: LanguageCode.hi, countryISO: 'in', code2: 'hi', code3: 'hin', name: 'हिंदी' }],
  [LanguageCode.hu, { value: LanguageCode.hu, countryISO: 'hu', code2: 'hu', code3: 'hun', name: 'Magyar' }],
  [LanguageCode.kk, { value: LanguageCode.kk, countryISO: 'kk', code2: 'kk', code3: 'kaz', name: 'Kazakh' }],
  [LanguageCode.ky, { value: LanguageCode.ky, countryISO: 'kg', code2: 'ky', code3: 'kir', name: 'Кыргызча' }],
  [LanguageCode.pl, { value: LanguageCode.pl, countryISO: 'pl', code2: 'pl', code3: 'pol', name: 'Polski' }],
  [LanguageCode.pt, { value: LanguageCode.pt, countryISO: 'pt', code2: 'pt', code3: 'por', name: 'Português' }],
  [LanguageCode.ru, { value: LanguageCode.ru, countryISO: 'ru', code2: 'ru', code3: 'rus', name: 'Русский' }],
  [LanguageCode.sl, { value: LanguageCode.sl, countryISO: 'si', code2: 'sl', code3: 'slv', name: 'Slovenski' }],
  [LanguageCode.tg, { value: LanguageCode.tg, countryISO: 'tj', code2: 'tg', code3: 'tgk', name: 'Тоҷикӣ' }],
  [LanguageCode.tr, { value: LanguageCode.tr, countryISO: 'tr', code2: 'tr', code3: 'tur', name: 'Türkçe' }],
  [LanguageCode.uk, { value: LanguageCode.uk, countryISO: 'ua', code2: 'ua', code3: 'ukr', name: 'Українська' }],
  [LanguageCode.uz, { value: LanguageCode.uz, countryISO: 'uz', code2: 'uz', code3: 'uzb', name: "O'zbek" }],
  [LanguageCode.vi, { value: LanguageCode.vi, countryISO: 'vn', code2: 'vn', code3: 'vie', name: 'Tiếng việt' }],
]);

export const editLanguageList = () => {
  return Array.from(AVAILABLE_LANGUAGES_MAP.values()).map((lang) => ({
    label: lang.name,
    value: lang.value,
  }));
};
